import { render, staticRenderFns } from "./detailFooterTable.vue?vue&type=template&id=4a746230"
import script from "./detailFooterTable.vue?vue&type=script&lang=js"
export * from "./detailFooterTable.vue?vue&type=script&lang=js"
import style0 from "./detailFooterTable.vue?vue&type=style&index=0&id=4a746230&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports